import {Controller, useFormContext} from "react-hook-form";
import {AuthorizationReviewReasonMap, AuthReviewNeededInput} from "../../domain";
import React, {memo} from "react";
import {DropdownMultiSelect} from "../../../../common";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../../placement/const";

type AuthReviewCommentInputProps = {
    sending: boolean;
    required?: boolean | undefined;
    fieldName?: keyof AuthReviewNeededInput | undefined;
    label?: string | undefined;
}

const AuthReviewRequestReasonsInput = memo((
    {
        sending,
        required = true,
        fieldName = 'authorizationReviewReasons',
        label = 'Authorization Review Reasons'
    }: AuthReviewCommentInputProps
) => {

    const {
        control,
        watch,
        setValue,
        clearErrors,
        formState: {
            errors
        },
    } = useFormContext<AuthReviewNeededInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="w-full">
                <div className="pb-2">
                    {label}
                </div>
                <div className="w-full">
                    <Controller
                        name={fieldName}
                        control={control}
                        rules={{
                            required: {
                                value: required,
                                message: 'Required'
                            },
                        }}
                        render={() =>
                            <DropdownMultiSelect
                                width="w-full"
                                field={'authorizationReviewReasons'}
                                options={Array.from(AuthorizationReviewReasonMap.keys())}
                                labelMapperFunc={(val) => AuthorizationReviewReasonMap.get(val)!!}
                                value={watch('authorizationReviewReasons')}
                                disabled={sending}
                                setValue={(selected) => {
                                    setValue("authorizationReviewReasons", splitAndRemoveEmpty(selected).join(SPLIT_DELIMITER))
                                    clearErrors("authorizationReviewReasons");
                                }}
                            />
                        }
                    />
                </div>
            </div>
            { errors.authorizationReviewReasons &&
                <div className="pt-2 flex w-full">
                    <div className="w-full text-red-700">
                        Please select “Authorization Review Reasons” before submitting
                    </div>
                </div>
            }
        </div>
    );
});

export default AuthReviewRequestReasonsInput;